import { ethereum } from '@0xtorch/core'
import { megaeth } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createMegaEthChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createMegaEthChainCustom({
    client: createClient({
      chain: megaeth,
      httpRpcs: megaEthHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'MegaETH Etherscan',
      baseUrl: 'https://mega.etherscan.io',
      chainId: 4326,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateMegaEthChainParameters = {
  client: Client
  explorer: Explorer
}

export const createMegaEthChainCustom = ({
  client,
  explorer,
}: CreateMegaEthChainParameters): Chain => ({
  id: 4326,
  network: 'megaeth',
  name: 'MegaETH',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'megaeth',
  defillamaId: 'megaeth',
})

export const megaEthHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.megaeth.com/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc-megaeth-mainnet.globalstake.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1rpc.io/megaeth',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://4326.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1_000n,
  },
  // getLogs is silently capped at 1000 results
  // {
  //   url: 'https://megaeth.blockscout.com/api/eth-rpc',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1_000n,
  // },
  // Free tier rate limit / no historical getLogs
  // {
  //   url: 'https://megaeth.drpc.org',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
]

export const megaEthWebsocketRpcUrls: readonly string[] = [
  'wss://mainnet.megaeth.com/ws',
  'wss://megaeth.drpc.org',
]
